(function () {
  var menu = document.querySelector('.js-menu');
  var nav = document.querySelector('.js-nav');

  if(menu)menu.addEventListener('click', menuOpen);


  function menuOpen(e){
    menu.classList.add('is-open')
    menu.removeEventListener('click', menuOpen)
    menu.addEventListener('click', menuClose)
    nav.classList.add('is-show')
  }

  function menuClose(e) {
    menu.classList.remove('is-open')
    menu.removeEventListener('click', menuClose)
    menu.addEventListener('click', menuOpen)
    nav.classList.remove('is-show')
  }
}());